import React from 'react';
import { Box, Typography, Link, Container, Divider } from '@mui/material';
import { Mail, GitHub, BugReport } from '@mui/icons-material';
import LicensingPage from './LicensingPage';

const ContactSection = () => {
  const emailSubject = "Feedback MHC Matchmaker";
  const encodedSubject = encodeURIComponent(emailSubject);
  const mailtoLink = `mailto:nicolas.debie@duke.edu?subject=${encodedSubject}`;
  
  // Replace with your actual GitHub repository URL
  const githubRepoUrl = "https://github.com/debienicolas/MHCMatchmaker";
  const githubIssuesUrl = `${githubRepoUrl}/issues`;

  return (
    <Box
      component="footer"
      className="contact-section"
      sx={{
        py: 2,
        px: 2,
        mt: 'auto',
      }}
    >
      <Container maxWidth="sm">
        <Typography variant="h6" align="center" gutterBottom sx={{ fontWeight: 'bold', color: '#333' }}>
          Contact Us
        </Typography>
        <Divider sx={{ mb: 2, width: '50%', mx: 'auto' }} />
        <Typography variant="body2" align="center" color="text.secondary" sx={{ mb: 2 }}>
          Have questions or feedback? We'd love to hear from you!
        </Typography>
        
        {/* Main contact links */}
        <Box sx={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', mb: 2, gap: 1 }}>
          <Link 
            href={githubIssuesUrl}
            target="_blank"
            rel="noopener noreferrer"
            color="primary" 
            sx={{ 
              mx: 1, 
              display: 'flex', 
              alignItems: 'center',
              '&:hover': { color: 'primary.dark' }
            }}
          >
            <BugReport sx={{ mr: 0.5, fontSize: '1rem' }} />
            Report Issue
          </Link>

          <Link 
            href={mailtoLink}
            color="primary" 
            sx={{ 
              mx: 1, 
              display: 'flex', 
              alignItems: 'center',
              '&:hover': { color: 'primary.dark' }
            }}
          >
            <Mail sx={{ mr: 0.5, fontSize: '1rem' }} />
            Email
          </Link>
          
          <Link 
            href={githubRepoUrl}
            target="_blank"
            rel="noopener noreferrer"
            color="primary" 
            sx={{ 
              mx: 1, 
              display: 'flex', 
              alignItems: 'center',
              '&:hover': { color: 'primary.dark' }
            }}
          >
            <GitHub sx={{ mr: 0.5, fontSize: '1rem' }} />
            GitHub
          </Link>
          
          <Link 
            href="/licensing"
            target="_blank"
            rel="noopener noreferrer"
            color="primary" 
            sx={{ 
              mx: 1, 
              display: 'flex', 
              alignItems: 'center',
              '&:hover': { color: 'primary.dark' }
            }}
          >
            Licensing
          </Link>
        </Box>

        <Divider sx={{ mb: 1, width: '70%', mx: 'auto' }} />
        <Typography variant="caption" color="text.secondary" align="center" display="block">
          {'Copyright © '}
          <Link color="inherit" href="https://mhcmatchmaker.com/">
            MHCMatchmaker
          </Link>{' '}
          {new Date().getFullYear()}
          {'.'}
        </Typography>
      </Container>
    </Box>
  );
};

export default ContactSection;
